import BasePart from './BasePart'

class Sequencer extends BasePart
  constructor: (audioContext, { scheduler, sequence }) ->
    super(audioContext)
    @sequence = sequence
    @currentStep = 0

    @instanceNode = @_createInstance()
    @connectedParts = []
    scheduler.on('tick', @next)

  _createInstance: ->
    @setInterface(@)

  setInterface: (destination) ->
    @interface = destination

  getInstance: ->
    @instanceNode

  getInterface: ->
    @instanceNode

  setValue: (sequence) ->
    @sequence = sequence

  getValue: ->
    @sequence

  next: (time, length) =>
    for connectedPart in @connectedParts
      value = @sequence[@currentStep]
      if value? and connectedPart.destination?
        connectedPart.setValue(value)
        connectedPart.trigger(time, length)

    @currentStep++

    if @currentStep is @sequence.length
      @currentStep = 0

  connect: (destination) ->
    if destination not in @connectedParts
      @connectedParts.push(destination)
    destination

  disconnect: (destination) ->
    @connectedParts = []
    destination


export default Sequencer
